import { Body } from "./Body";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Root } from "./Root";

export const CustomModal = {
	Root,
	Header,
	Body,
	Footer,
};
